import { render, staticRenderFns } from "./DataTextarea.vue?vue&type=template&id=cf9654fe&scoped=true"
import script from "./DataTextarea.vue?vue&type=script&lang=js"
export * from "./DataTextarea.vue?vue&type=script&lang=js"
import style0 from "./DataTextarea.vue?vue&type=style&index=0&id=cf9654fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9654fe",
  null
  
)

export default component.exports